const SERVICE_MESSAGES = Object.freeze({
  VOLCENGINE_CHAT_SERVICE_PAUSED: 'AI 导游服务太火爆了，请稍后再试',
  VOLCENGINE_VIDEO_SERVICE_PAUSED: '视频生成服务太火爆了，请稍后再试',
  RECONSTRUCTION_SERVICE_PAUSED: '重建服务太火爆了，请稍后再试'
})

export function getServicePausedMessage(error) {
  const code = String(
    error?.code ||
    error?.response?.data?.code ||
    error?.payload?.code ||
    error?.payload?.error?.code ||
    ''
  ).trim()
  return SERVICE_MESSAGES[code] || ''
}
